import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { FilterChipRow } from "/imports/ui/components/shared";
import { RANGE_SCOPE_OPTIONS } from "../trainerScheduleHelpers";

function ListRangeControls({ isRangeMode, fromDate, setFromDate, toDate, setToDate, rangeScope, setRangeScope, loading, onLoadRange, onClearRange }) {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Typography variant="body2" color="text.secondary">
          {isRangeMode ? "Date range:" : "Showing today & tomorrow. Pick a date range:"}
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5 }}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <MobileDatePicker
              label="From"
              value={fromDate}
              onChange={setFromDate}
              format="dd LLL yyyy"
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              sx={{ flex: 1, minWidth: "8.125rem", maxWidth: { sm: 200 } }}
            />
            <MobileDatePicker
              label="To"
              value={toDate}
              onChange={setToDate}
              minDate={fromDate || undefined}
              format="dd LLL yyyy"
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              sx={{ flex: 1, minWidth: "8.125rem", maxWidth: { sm: 200 } }}
            />
          </LocalizationProvider>
          <Button variant="contained" size="small" onClick={onLoadRange} disabled={loading || (!fromDate && !toDate)} sx={{ flexShrink: 0 }}>
            Load
          </Button>
          {isRangeMode && (
            <Button size="small" onClick={onClearRange} disabled={loading} sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
              Back to today &amp; tomorrow
            </Button>
          )}
        </Box>
        {isRangeMode && <FilterChipRow options={RANGE_SCOPE_OPTIONS} value={rangeScope} onSelect={(v) => v && setRangeScope(v)} />}
      </CardContent>
    </Card>
  );
}

export default ListRangeControls;
